/* eslint-disable no-await-in-loop */
/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react'
import cloneDeep from 'lodash/cloneDeep'
import { message } from 'antd'
import Tooltip from 'meinian-package/src/baseComponent/tooltip'
import image from 'image/comment_empty.png'
import logo from 'image/logo_icon.png'
import { ossImg } from 'meinian-package/src/utils/image'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import Icon from 'meinian-package/src/component/icon'
import request from 'meinian-package/src/utils/request'
import { Empty } from 'meinian-package/src/baseComponent'
import { formatTime } from '../../../../component/util'
import { hasAnnotationAuth } from '../detailAuth'
import './note.less'

const THUMBNAIL_SIZE = 112 // 缩略图的尺寸（w/h）

export default ({
  notes,
  setNotes,
  setActiveNoteIndex,
  setIsAnnotate,
  isAnnotate,
  isMove,
  _onChange,
  loginUserInfo,
  originImage,
  mainUrl,
}) => {
  const [convertNotes, setConvertNotes] = useState([])

  useEffect(() => {
    if (isMove) return
    const newData = cloneDeep(notes)
    setConvertNotes([...newData.reverse()])
  }, [JSON.stringify(notes), isMove, originImage])

  const onDelete = async (note) => {
    ModalConfirm.show({
      title: '确定要删除该批注吗？',
      content: '当批注被删除后，该批注的内容将不可恢复',
      onOk: async () => {
        try {
          deleteNote(note)
        } catch (err) {
          message.error('删除失败，请稍后再尝试删除')
        }
      }
    })
  }

  const onEdit = (note) => {
    const index = notes.findIndex(item => item.id == note.id)
    setActiveNoteIndex(index || 0)
    setNotes(pre => {
      return pre.map(item => {
        if (item.id == note.id) {
          return {
            ...item,
            editMode: true,
            isShowNote: true
          }
        }
        return {
          ...item,
          editMode: false,
          isShowNote: false
        }
      })
    })
  }

  const deleteNote = async (note) => {
    try {
      await request.post('/zhikuan/annotation/delete-blog-annotation', {
        entityId: note?.entityId,
        inspirationId: note?.inspirationId,
        id: note.id,
        mainUrl: note?.mainUrl,
      })
      setNotes(pre => pre.filter(m => m.id !== note.id))
      _onChange?.({ annotationNum: notes.filter(m => m.id !== note.id).length })
    } catch (err) {
      console.error(err)
      if (err.errorCode === 'U04') {
        message.error('没有删除权限')
      }
    }
  }

  const clickNote = (index, e) => {
    e && e.stopPropagation()
    setActiveNoteIndex(index)
    setIsAnnotate(false)
    setNotes(pre => {
      return pre.map((item, i) => {
        if (index === i) {
          if (item?.isShowNote) {
            return { ...item, isShowNote: false, editMode: false }
          }
          return { ...item, isShowNote: true }
        }
        return { ...item, isShowNote: false, editMode: false }
      })
    })
  }
  const auth = loginUserInfo?.inspirationPermissions || []

  return <div className="detail-note-list">
    {convertNotes.filter(i => i.confirm)?.length ? convertNotes.filter(i => i.confirm).map((item, index) => {
      const { xmin, ymin, xmax, ymax, width, height } = item
      const tempWidth = originImage?.width || width
      const tempHeight = originImage?.height || height

      const position = computeThumbnail({
        xmin,
        ymin,
        xmax,
        ymax,
        width: tempWidth,
        height: tempHeight,
      })
      console.log('position', item, tempWidth, tempHeight)
      return <div
        key={item.id}
        className="note-item"
        onClick={(e) => { clickNote(convertNotes.length - index - 1, e) }}
        data-id={item.id}
        id={`note-${convertNotes.length - index - 1}`}
      >
        <div
          className="note-thumbnail"
        >
          {
            position ? <div style={{
              transform: `scale(${position.scaleX}, ${position.scaleY})`,
              transformOrigin: `${position.centreX}px ${position.centreY}px`,
              width: position.width,
              height: position.height,
              overflow: 'hidden'
            }}
            >
              <div style={{
                width: tempWidth,
                height: tempHeight,
                background: `url(${ossImg(mainUrl)}) no-repeat`,
                backgroundSize: 'cover',
                backgroundPosition: `-${(xmin * tempWidth)}px -${(ymin * tempHeight)}px` }}
              />
            </div>
              : <div className="note-thumbnail-empty"><img src={logo} /></div>
          }
          <div className="note-index">{index + 1}</div>
        </div>
        <div className="node-info">
          <div className="author-img">
            <img src={item?.avatar} alt="" />
          </div>
          <div className="info-introduction">
            <div className="node-author text-overflow">{item?.userName}</div>
            <div style={{ flex: 1 }}>
              <Tooltip title={item?.annotationContent}>
                <div className="node-content">
                  {item?.annotationUrl ? <Icon type="m-chuntumoshi" /> : null}
                  <span>{item?.annotationContent}</span>
                </div>
              </Tooltip>
            </div>
            <div className="node-footer">
              <div className="node-create">{formatTime(item?.updatedAt, 'YYYY-MM-DD HH:mm:ss')}</div>
              {
                hasAnnotationAuth(auth, item.userId) && <div className="node-operation">
                  <span onClick={() => onDelete(item)}>删除</span>
                  <span onClick={(e) => {
                    e.stopPropagation()
                    setActiveNoteIndex(convertNotes.length - index - 1)
                    setIsAnnotate(false)
                    onEdit(item)
                  }}
                  >修改</span>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }) : <Empty
      image={image}
      title={
        <div>当前图片暂无批注，点击
          <span onClick={() => setIsAnnotate(!isAnnotate)} style={{ color: '#0065D9', marginLeft: 4, cursor: 'pointer' }}>新增批注</span>
        </div>
      }
    />}
  </div>
}

const computeThumbnail = (position) => {
  const { xmax, xmin, ymax, ymin, width, height } = position
  const cutWidth = (xmax - xmin) * width
  const cutHeight = (ymax - ymin) * height
  // const originScaleX = (cutWidth / THUMBNAIL_SIZE)
  // const originScaleY = (cutHeight / THUMBNAIL_SIZE)

  if (cutWidth && cutHeight) {
    let scaleX = 1
    let scaleY = 1
    const centreX = 0
    const centreY = 0
    scaleX = THUMBNAIL_SIZE / cutWidth
    scaleY = THUMBNAIL_SIZE / cutHeight
    // if (cutWidth > THUMBNAIL_SIZE && cutHeight > THUMBNAIL_SIZE) {
    //   const ratio = cutHeight / cutWidth
    //   if (cutWidth > cutHeight) {
    //     const _height = cutHeight / originScaleX
    //     scaleX = THUMBNAIL_SIZE / cutWidth
    //     scaleY = (THUMBNAIL_SIZE / cutHeight) * ratio
    //     centreY = (THUMBNAIL_SIZE - _height)
    //   } else {
    //     const _width = cutWidth / originScaleY
    //     scaleX = THUMBNAIL_SIZE / cutWidth / ratio
    //     scaleY = (THUMBNAIL_SIZE / cutHeight)
    //     centreX = (THUMBNAIL_SIZE - _width) - _width / 2
    //   }
    // } else if (cutWidth < THUMBNAIL_SIZE && cutHeight < THUMBNAIL_SIZE) {
    //   // empty
    // } else if ((cutWidth > THUMBNAIL_SIZE && cutHeight < THUMBNAIL_SIZE) || (cutWidth < THUMBNAIL_SIZE && cutHeight > THUMBNAIL_SIZE)) {
    //   if (cutWidth > cutHeight) {
    //     const _width = cutWidth / originScaleX
    //     const _height = cutHeight / originScaleX
    //     scaleX = _width / cutWidth
    //     scaleY = _height / THUMBNAIL_SIZE
    //     centreY = (THUMBNAIL_SIZE - _height) / 2
    //   } else {
    //     const _width = cutWidth / originScaleY
    //     const _height = cutHeight / originScaleY
    //     scaleX = _width / THUMBNAIL_SIZE
    //     scaleY = _height / cutHeight
    //     centreX = (THUMBNAIL_SIZE - _width) - _width
    //   }
    // }

    return {
      width: cutWidth,
      height: cutHeight,
      scaleX,
      scaleY,
      centreX,
      centreY,
    }
  }
  return null
}
